import type { SelectOption } from '../../../../types';
import type { ExpirationValue } from './types';

export const expirationOptions: Array<SelectOption<ExpirationValue | null>> = [
  { label: '30 Days', value: { numerator: 30, unit: 'days' } },
  { label: '6 Months', value: { numerator: 6, unit: 'months' } },
  { label: '1 Year', value: { numerator: 1, unit: 'year' } },
  { label: 'Never', value: null },
];
